import { Directive, ElementRef, Input } from '@angular/core';
import { RbacService } from '../../services/rbac/rbac.service';

@Directive({
  selector: '[hasAccess]',
  standalone: true
})
export class HasAccessDirective{

  @Input('hasAccess') data: string[];

  constructor(private elementRef: ElementRef, private readonly rbacService: RbacService) {
    this.rbacService.getIsPermissionUpdated().subscribe((res) => {
      if(res) {
        this.ngOnInit();
      }
    })
  }


  ngOnInit(): void {
    if(!this.data) {
      this.elementRef.nativeElement.style.display = 'block';
      return;
    }
    const [feature, action] = this.data;
    if(action) {
      let actionsData = this.rbacService.getActionDataForFeature(feature.toLowerCase());
        actionsData = actionsData?.map(val=>val?.toLowerCase())
        if(!actionsData?.includes(action?.toLowerCase())){
          this.elementRef.nativeElement.style.setProperty('display', 'none', 'important');
        }
        else{
          this.elementRef.nativeElement.style.display = 'block';
        }
    }
  }

}
